import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.config({
  autoSleep: 60,
  force3D: true,
  nullTargetWarn: false,
  trialWarn: false,
  units: {
    left: "%",
    top: "%",
    rotation: "rad",
  },
});

export class MainMenu {
  constructor(el) {
    this.el = el;
    this.menuBox = el.querySelector("[data-menu-box]");
    this.bgBox = el.querySelector("[data-menu-background]");
    this.timeline = null;
  }

  Reset() {
    gsap.set(this.el, { x: "0%" });
    this.timeline != null ? this.timeline.kill() : "";
  }

  Open() {
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline();

    this.timeline.to(
      this.el,
      {
        x: "-100%",
      },
      "beforeOpen"
    );
  }

  Close() {
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline();

    this.timeline.to(
      this.el,
      {
        x: "0%",
      },
      "afterClose"
    );
  }
}
